import {ColonistOneTimePurchaseType} from '@colonist/types'
import {UIStoreGiftOverlayController} from '../../../../../shared/scripts/store/gift/UIStoreGiftOverlayController'
import {UIMMobileWebviewCommunication} from '../../../ui_mobile_communication/UIMMobileWebviewCommunication'
import {MobileWebviewCommunicationActions} from '@colonist/mobile'
import {GiftPurchaseData} from '../../../../../../shared/store/GiftPurchaseData'

export class UIMStoreGiftOverlayController extends UIStoreGiftOverlayController {
    protected async executeCheckout(giftTier: ColonistOneTimePurchaseType, giftPurchaseData: GiftPurchaseData) {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true)
        await super.executeCheckout(giftTier, giftPurchaseData)
    }
}
